import { toFormData } from '../lib/utils/forms';
import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type UploadFilesRequest = {
    files: File[];
};

export type UploadFilesResponse = {
    files: string[];
};

export const uploadFiles = async (body: UploadFilesRequest): Promise<string[]> => {
    const response = await axiosAPI.post<ApiResponse<UploadFilesResponse>>('/v1/files/upload', toFormData(body));

    if (response.data.status === 'success' && response.data.data?.files) {
        return response.data.data.files;
    }

    throw new Error('Ошибка загрузки файлов');
};
